// extracted by mini-css-extract-plugin
module.exports = {"container":"FrontpageContactPart_container__DsFyl","header":"FrontpageContactPart_header__flP2I","links":"FrontpageContactPart_links__1Apar"};